import { useSearchParams } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import ContactForm from "@/components/ContactForm";
import Seo from "@/components/Seo";
import { Reveal, Eyebrow, RevealLines } from "@/components/Reveal";

export default function Contatti() {
  const [searchParams] = useSearchParams();
  const motivo = searchParams.get("motivo");
  const initialReason = motivo === "Valutazione" ? "Consulenza" : motivo || "Vendita";

  return (
    <div data-testid="contatti-page" className="pt-28 lg:pt-32">
      <Seo
        title="Contatti — IDEAL REAL ESTATE Milano"
        description="Contatta IDEAL REAL ESTATE a Milano: telefono, WhatsApp ed email per vendite, acquisti, locazioni e consulenze. Parliamo del tuo prossimo progetto immobiliare."
        path="/contatti"
      />
      <header className="mx-auto max-w-[1440px] px-6 pb-16 lg:px-12">
        <Reveal><Eyebrow>Contatti</Eyebrow></Reveal>
        <h1>
          <RevealLines
            lines={["Parliamo del tuo", "prossimo progetto immobiliare."]}
            className="mt-5 max-w-4xl font-serif text-4xl font-medium leading-[1.05] lg:text-6xl"
          />
        </h1>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-mut lg:text-lg">
            Vendita, acquisto, locazione o consulenza: raccontaci il tuo progetto, ti
            risponderemo al più presto.
          </p>
        </Reveal>
      </header>

      <section className="mx-auto max-w-[1440px] px-6 pb-24 lg:px-12 lg:pb-32">
        <div className="grid gap-16 lg:grid-cols-12">
          {/* Canali diretti */}
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <a
                href="https://wa.me/393520042494"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-direct-link"
                className="group flex items-center justify-between gap-4 bg-ink p-7 text-sand transition-colors duration-300 hover:bg-champagne"
              >
                <span className="flex items-center gap-4">
                  <MessageCircle className="h-6 w-6" />
                  <span>
                    <span className="block text-[11px] uppercase tracking-wide2 text-sand/60">WhatsApp</span>
                    <span className="mt-1 block font-serif text-2xl">Chatta con noi</span>
                  </span>
                </span>
                <span className="font-mono text-sm text-sand/70 group-hover:text-sand">+39 352 004 2494</span>
              </a>
            </Reveal>

            <div className="mt-10 space-y-7">
              {[
                { Icon: Phone, label: "Telefono", value: "+39 352 004 2494", href: "tel:+393520042494", testId: "contact-phone-link" },
                { Icon: Mail, label: "Email", value: "idealrealestatesrl@gmail.com", href: "mailto:idealrealestatesrl@gmail.com", testId: "contact-email-link" },
                { Icon: MapPin, label: "Sede", value: "Via Soperga 16, 20127 Milano", href: null, testId: "contact-address" },
                { Icon: Clock, label: "Orari", value: "Lun — Ven · 9:00 — 18:30", href: null, testId: "contact-hours" },
              ].map(({ Icon, label, value, href, testId }, i) => (
                <Reveal key={label} delay={0.15 + i * 0.07}>
                  <div className="flex items-start gap-5 border-b border-ink/10 pb-6">
                    <Icon className="mt-1 h-5 w-5 text-champagne" />
                    <div>
                      <p className="text-[11px] uppercase tracking-wide2 text-mut">{label}</p>
                      {href ? (
                        <a href={href} data-testid={testId} className="mt-1 block font-serif text-xl text-ink transition-colors hover:text-champagne">
                          {value}
                        </a>
                      ) : (
                        <p className="mt-1 font-serif text-xl text-ink" data-testid={testId}>{value}</p>
                      )}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="border border-ink/10 bg-sand2 p-8 lg:p-14" data-testid="contatti-form-card">
                <ContactForm variant="contatti" reason={initialReason} key={initialReason} />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
